<script>
export default {
  props: {
    classCustom: {
      default: () => {
        return ''
      },
      type: String,
    },
  },
}
</script>

<template>
  <svg
    width="25"
    height="18"
    viewBox="0 -3 35 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    :class="classCustom"
  >
    <path d="M35.3516 0H0V7.29462H35.3516V0Z" fill="#B7B7B7" />
    <path
      d="M0 28.1369H20.2754V17.0209H28.4718V28.1362H35.3516V9.37891H0V28.1369ZM6.23831 16.6742H11.7834V22.2319H6.23831V16.6742Z"
      fill="#B7B7B7"
    />
  </svg>
</template>
